import createRequest from '../core/request'

/**
 * 获取消息数
 * https://web-api.intsig.net/project/613/interface/api/172253
 */
export function getLatestMessage(params) {
  return createRequest('CORPAPI').get('/user/message/user_message_num', {
    params
  })
}

/**
 * 获取名片共享列表
 */
export function getMsgList(params) {
  return createRequest('CORPAPI').get('/user/message/list', {
    params
  })
}

/**
 * 审批申请加入消息
 */
export function setApply(params, data) {
  return createRequest('CORPAPI').post(`/user/message/apply/deal`, data, {
    params
  })
}
/**
 * 设置已读状态
 */
export function setRead(params, data) {
  return createRequest('CORPAPI').post(`/user/message/read`, data, {
    params
  })
}
/**
 * 全部设置已读状态
 * https://web-api.intsig.net/project/613/interface/api/172256
 */
export function setReadAll(params) {
  return createRequest('CORPAPI').get('/user/message/readAll', {
    params
  })
}
